module.exports = "/images/lena.webp?f9cf8df55225de23d9ad5a2519174d9f";